// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '../static/dist/fullpage.min.css'
// import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from '../static/dist/vue-fullpage.js'

import 'lib-flexible'

Vue.use(VueFullPage);
Vue.use(ElementUI);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data(){
    return{
      indexTabList:[{
        value: '0',
        label: "首页",
        path:'/index',
        isActive:true
      },{
        value:'1',
        label:'核心产品',
        path:'/coreProduct',
        isActive:false
      },{
        value:'2',
        label:'市场合作',
        path:'/cooperation',
        isActive:false
      },{
        value:'3',
        label:'关于我们',
        path:'/aboutUs',
        isActive:false
      }]
    }
  },
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js